/**
 * Custom back-button, used for correct redirection on unique cases instead of back-angle button
 */
import { LitElement, customElement, html } from 'lit-element';

/**
 * LitElement
 * A simple base class for creating fast, lightweight web components.
 *
 *
 * @docs https://lit-element.polymer-project.org/
 */
@customElement('double-back-button')
class DoubleBackButtonComponent extends LitElement {
  static get properties() {
    return {
      screen: { type: String },
    };
  }

  constructor() {
    super();
    this.screen = '';
  }

  render() {
    return html`
        <div
          class="double-back-button"
          @click=${() => this.back()}
        >
          <i
            class="fa fa-angle-left"
          >
          </i>
        </div>
      `;
  }

  back() {
    this.kasko.dispatchEvent('go-to-screen', { screen: this.screen });
  }

  createRenderRoot() {
    return this;
  }
}

export default DoubleBackButtonComponent;
